import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { driverState } from './driverState';
import { DriversState } from '../types';

export const driverSlice = createSlice({
  name: 'drivers',
  initialState: driverState,
  reducers: {
    setDrivers: (state, action: PayloadAction<DriversState['drivers']>) => {
      state.drivers = action.payload;
    },
    setTerminals: (state, action: PayloadAction<DriversState['terminals']>) => {
      state.terminals = action.payload;
    },
    setSubsets: (state, action: PayloadAction<DriversState['subSets']>) => {
      state.subSets = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    setTotalRecordCounts: (state, action: PayloadAction<number>) => {
      state.totalRecordCount = action.payload;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setSortField: (state, action: PayloadAction<string>) => {
      state.sortField = action.payload;
    },
    setRecordId: (state, action: PayloadAction<string>) => {
      state.recordId = action.payload;
    },
    setHomeTerminalId: (state, action: PayloadAction<Array<number>>) => {
      state.homeTerminalId = action.payload;
    },
    setCreateUpdateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.createUpdateModalOpen = action.payload;
    },
    setSelectedDriverId: (state, action: PayloadAction<number | undefined>) => {
      state.selectedDriverId = action.payload;
    },
    setHosCarrierProperties: (
      state,
      action: PayloadAction<DriversState['hosCarrierProperties']>,
    ) => {
      state.hosCarrierProperties = action.payload;
    },
    setExportModalOpen: (state, action: PayloadAction<boolean>) => {
      state.exportModalOpen = action.payload;
    },
    setCsvExportModalOpen: (state, action: PayloadAction<boolean>) => {
      state.csvExportModalOpen = action.payload;
    },
    setResetData: () => {
      return driverState;
    },
  },
});

export const { actions: driverActions } = driverSlice;

export const selectDrivers = (state: RootState) => state.drivers;

export const selectDriversList = createSelector(
  selectDrivers,
  drivers => drivers.drivers,
);

export const selectTerminals = createSelector(
  selectDrivers,
  drivers => drivers.terminals,
);

export const selectSubsets = createSelector(
  selectDrivers,
  drivers => drivers.subSets,
);

export const selectColumns = createSelector(
  selectDrivers,
  drivers => drivers.columns,
);

export const selectJobSiteLimit = createSelector(
  selectDrivers,
  drivers => drivers.limit,
);
export const selectDriversPageIndex = createSelector(
  selectDrivers,
  drivers => drivers.pageIndex,
);
export const selectDriversTotalRecordCount = createSelector(
  selectDrivers,
  drivers => drivers.totalRecordCount,
);
export const selectDriversSortBy = createSelector(
  selectDrivers,
  drivers => drivers.sortBy,
);
export const selectDriversSortField = createSelector(
  selectDrivers,
  drivers => drivers.sortField,
);
export const selectRecordId = createSelector(
  selectDrivers,
  drivers => drivers.recordId,
);
export const selectHomeTerminalId = createSelector(
  selectDrivers,
  drivers => drivers.homeTerminalId,
);

export const selectCreateUpdateModalOpen = createSelector(
  selectDrivers,
  drivers => drivers.createUpdateModalOpen,
);

export const selectSelectedDriverId = createSelector(
  selectDrivers,
  drivers => drivers.selectedDriverId,
);

export const selectHosCarrierProperties = createSelector(
  selectDrivers,
  drivers => drivers.hosCarrierProperties,
);

export const selectExportModalOpen = createSelector(
  selectDrivers,
  drivers => drivers.exportModalOpen,
);

export const selectCsvExportModalOpen = createSelector(
  selectDrivers,
  drivers => drivers.csvExportModalOpen,
);

export default driverSlice.reducer;
